import upload from "@/template/js/v32/upload";
import api from "@/conf/js/api";

export default {

    field: [],

    /**
     * 更新已经填写的字段
     * @param field
     */
    updateFillField(field) {

        if (field) {
            let ele = null
            for (let i in field) {
                ele = document.getElementsByName(i)[0];
                if (ele) {
                    switch (field[i].type) {
                        case  "text" :
                        case  "date" :
                            this.setInput(i, field[i].value, true)
                            break;
                        case  "checkbox" :
                            ele.checked = true;
                            ele.disabled = "disabled"
                            break;
                        case  "select" :
                            let selectList = ele.getElementsByTagName("option");
                            for (let selectKey in selectList) {
                                if (selectList[selectKey].value === field[i].value)
                                    ele[selectKey].selected = true
                            }
                            ele.disabled = "disabled"
                            break;
                        case  "radio" :
                            document.getElementsByName(i).forEach((item, index) => {
                                if (document.getElementsByName(i)[index].value === field[i].value) {
                                    document.getElementsByName(i)[index].checked = true
                                }
                                document.getElementsByName(i)[index].disabled = "disabled"
                            })
                            break;
                        case  "image" :
                            let style = window.getComputedStyle(document.getElementById(i).parentElement);
                            //创建图片预览节点
                            document.getElementById(i).parentElement.appendChild(this.imgCreate(field[i].value_show, style.width, style.height));
                            break;
                    }
                }
            }

        }


    },

    /**
     * 获取tag
     * @param obj
     * @returns {HTMLCollectionOf<*>}
     */
    getTagName(obj) {
        return document.getElementById("pageContainer").getElementsByTagName(obj)
    },
    /**
     * 更新时间控件
     * @param successFun
     */
    updateTimeObj(successFun) {
        let list = this.getTagName("input");
        //对表单中所有的input进行遍历
        for (let i = 0; i < list.length && list[i]; i++) {
            if (list[i].getAttribute("data-type") === "date") {
                document.getElementById(list[i].id).addEventListener("click", (event) => {
                    successFun(event, list[i].id, document.getElementById(list[i].id).value)
                });
            }
        }
    },
    /**
     * 获取所有填写的内容
     * @returns {{}}
     */
    getFiledContent() {

        let list = this.getTagName("input");
        let data = {};
        //对表单中所有的input进行遍历
        for (let i = 0; i < list.length && list[i]; i++) {
            switch (list[i].type) {
                case  "text" :
                    if (list[i].value)
                        data[list[i].name] = list[i].value
                    break;
                case  "radio" :
                case  "checkbox" :
                    if (list[i].checked)
                        data[list[i].name] = list[i].value
                    break;
            }
        }

        let select = this.getTagName("select");
        //对表单中所有的input进行遍历
        for (let i = 0; i < select.length && select[i]; i++) {
            if (select[i].selectedIndex) {
                data[select[i].name] = select[i][select[i].selectedIndex].value
            }
        }

        //textarea
        let textarea = this.getTagName("textarea");
        //对表单中所有的input进行遍历
        for (let i = 0; i < textarea.length && textarea[i]; i++) {
            if (textarea[i].value) {
                data[textarea[i].name] = textarea[i].value
            }
        }

        return data;
    },

    /**
     * 初始化
     * @param field
     */
    init(field) {

        this.field = field
        return this
    }
    ,
    /**
     * 开始处理
     */
    handle() {

        this.createImage()
        this.field.forEach((item, index) => {


            if (item.option) {

                let id = this.getId(item.name);
                switch (item.type) {
                    case "radio" :
                        this.setFieldOption(item.name, item.option.data)
                        break;
                    case "checkbox" :
                        this.setFieldOption(item.name, [item.option.data])
                        break;
                    case "image" :
                    case "qrcode" :
                    case "signature" :
                    case "signature_place" :

                        break;
                    case "date" :
                        this.setInput(item.name, item.content ? item.content : "", false)
                        document.getElementById(id).setAttribute("data-type", "date");
                        break;
                    case "date_auto" :
                    case "number" :
                        this.setInput(item.name, item.content ? item.content : "", true)
                        break;
                    default :
                        item.content && this.setInput(item.name, item.content, false)
                        break;
                }

            }

        })

    },

    /**
     * 获取json
     * @returns {{type}|any|null}
     */
    getConfigJson(element){
      try {


          let desc = element.parentElement.getAttribute("title");

          let json = JSON.parse(desc);
          if (json.type)
          return json;
      }
      catch (e) {
          return {
              type :  'note'
          }
      }
    },
    /**
     * btn 事件
     */
    createImage() {

        let link = document.getElementsByClassName("internalLink");

        for (let i in link) {

            if (link[i].parentElement) {

                let json = this.getConfigJson(link[i] );

                switch (json.type) {
                    case "image" :
                        //创建input
                        this.createFileInput(link[i], json)
                        break;
                    case "signature" :
                    case "signature_place" :
                        //创建input
                        this.createSigned(link[i], json)
                        break;
                    case "qrcode" :
                        let style = window.getComputedStyle(link[i].parentElement);
                        //创建图片预览节点
                        link[i].parentElement.appendChild(this.imgCreate("https://oss2.1dq.com/public/qrcode.png", style.width, style.height));
                        break;
                }

            }
        }

    },
    /**
     * 创建签署区域
     * @param note
     * @param type
     */
    createSigned(note , type) {
        let div = document.createElement("div");
        div.innerHTML = type==='signature_place'?"骑缝章":"签署区";
        div.className = "font-signed"

        note.style.display = "none"
        note.parentElement.setAttribute("title",  "合同发起后可在此区域盖章或签字")
        note.parentElement.style.transform = "unset"
        note.parentElement.style.background = "rgb(238 238 238 / 90%)"
        note.parentElement.style.border = "1px dashed #7f7d7d"
        note.parentElement.appendChild(div)

        //绑定点击事件
        div.onclick = function () {
            api.alert("合同发起后或者填写成功后可在此区域盖章或签字")
        }
    },
    /**
     * 创建输入框
     * @param type
     * @param name
     * @returns {HTMLInputElement}
     */
    inputCreate(type, name) {
        let div = document.createElement("input");
        div.type = type;
        div.id = name;
        div.name = name;
        div.value = "";
        if (type === 'file')
            div.accept = "image/*"
        div.style.display = "none";
        return div;

    },
    /**
     * 创建img节点
     * @param id
     * @param src
     * @param width
     * @param height
     */
    imgCreate(src, width, height) {
        let div = document.createElement("img");

        div.src = src
        div.style.width = width;
        div.style.height = height;
        div.style.position = "absolute";
        div.style.left = "0px";
        div.style.top = "0px";
        div.style.zIndex = 3;
        div.style.background = "#ffffff";
        div.style.display = "block";
        return div;
    },
    /**
     * 创建删除框
     * @param id
     * @returns {HTMLDivElement}
     */
    delDivCreate() {
        let div = document.createElement("div");
        div.className = "delete-box"
        div.innerHTML = "x"
        div.onclick = function (event) {
            let ele = event.target.parentElement;
            //清空输入框
            if (ele.getElementsByTagName("input")[1])
                ele.getElementsByTagName("input")[1].value = "";
            //删除img
            if (ele.getElementsByTagName("img")[0])
                ele.removeChild(ele.getElementsByTagName("img")[0])
            //删除当前节点
            ele.removeChild(event.target)
        }
        return div;
    },
    /**
     * 创建file 节点
     * @param note
     * @param json
     */
    createFileInput(note, json) {
        let style = window.getComputedStyle(note.parentElement);
        let that = this
        let file_id = note.parentElement.getAttribute("data-annotation-id") + '-file';
        let text_field_name = json.field_name ? json.field_name : "note";

        note.style.display = "none"

        let div = document.createElement("div");
        div.innerHTML = json.desc ? json.desc : "点击上传图片";
        div.className = "font-signed"
        note.parentElement.appendChild(div)

        note.parentElement.style.transform = "unset"
        note.parentElement.style.background = "#dde6ffde"
        note.parentElement.style.border = " 1px solid transparent"
        note.parentElement.setAttribute("title", json.desc ? json.desc : "点击上传图片")
        //创建节点
        note.parentElement.appendChild(this.inputCreate("file", file_id));
        note.parentElement.appendChild(this.inputCreate("text", text_field_name));


        //绑定点击事件
        div.onclick = function () {
            return  document.getElementById(file_id).click()
        }
        //绑定文件选择完成事件
        document.getElementById(file_id).onchange = () => {
            //file文件
            let tmp_files = document.getElementById(file_id).files[0];
            //执行上传请求
            upload.handle(document.getElementById(file_id).files[0], "attachment", function (json) {
                //上传成功
                document.getElementById(text_field_name).value = json.file_id
                //图片预览
                let reads = new FileReader();
                reads.readAsDataURL(tmp_files);
                reads.onload = function (e) {
                    //创建图片预览节点
                    note.parentElement.appendChild(that.imgCreate(this.result, style.width, style.height));
                    //创建删除节点
                    note.parentElement.appendChild(that.delDivCreate());
                };

            })
        }
    },

    /**
     * 设置多选框，单选框
     * @param name
     * @param field_option
     */
    setFieldOption(name, field_option) {

        if (field_option) {
            field_option.forEach((item2, index2) => {
                if (document.getElementsByName(name)[index2])
                    document.getElementsByName(name)[index2].value = index2;
            })
        }
    }
    ,
    /**
     * 设置输入框
     * @param name
     * @param content
     * @param readonly
     */
    setInput(name, content, readonly) {

        if (document.getElementsByName(name)[0]) {
            document.getElementsByName(name)[0].value = content

            if (readonly) {
                document.getElementsByName(name)[0].readOnly = "readonly"
                document.getElementsByName(name)[0].style.background = "none"
            }
        }

    },

    /**
     * 获取id
     * @param name
     * @returns {string}
     */
    getId(name) {

        let ele = document.getElementsByName(name)[0];

        if (!ele)
            return null;
        return ele.id

    }
    ,
    getDateConfig(format_type) {
        // let date = new Date()
        // beginYear: date.getFullYear().toString(),//此项为Mdate的初始年份，不填写默认为2000
        //     beginMonth: (date.getMonth() + 1).toString(),//此项为Mdate的初始月份，不填写默认为1
        //     beginDay: date.getDate().toString(),//此项为Mdate的初始日期，不填写默认为1
        return {
            beginYear: "2002",//此项为Mdate的初始年份，不填写默认为2000
            beginMonth: "10",//此项为Mdate的初始月份，不填写默认为1
            beginDay: "24",//此项为Mdate的初始日期，不填写默认为1
            format: format_type//此项为Mdate需要显示的格式，可填写"/"或"-"或".",不填写默认为年月日
        }
    }


}
